// `date` is `shopInfo.data.created_at`, which is empty/undefined for the
// brief window before shopInfo has loaded. All three checks below used to
// fall through and implicitly `return undefined` in that window — a falsy
// value every `checkIsStoreXNew({...}) ? new : old` call site reads as "old
// store," so every one of them briefly routed to (or rendered) the
// deprecated V1/V3 pages before snapping to the correct one once shopInfo
// resolved. Since every real currently-active shop was created long after
// each versionChangeDate below, defaulting to "new" while we don't know yet
// is virtually always correct and never shows the deprecated experience;
// defaulting to "old" (the previous behavior) was virtually always wrong.
export const checkIsStoreNew = ({ date }) => {
  if (!date) return true;
  const createdAt = new Date(date);
  if (Number.isNaN(createdAt.getTime())) return true;

  const versionChangeDate = new Date('2021-09-29'); // replace with your second date

  return createdAt >= versionChangeDate;
};

export const checkIsStoreBOGONew = ({ date }) => {
  if (!date) return true;
  const createdAt = new Date(date);
  if (Number.isNaN(createdAt.getTime())) return true;

  const versionChangeDate = new Date('2025-08-23'); // replace with your second date

  return createdAt >= versionChangeDate;
};

export const checkIsStoreDashboardNew = ({ date }) => {
  if (!date) return true;
  const createdAt = new Date(date);
  if (Number.isNaN(createdAt.getTime())) return true;

  const versionChangeDate = new Date('2021-02-09'); // replace with your second date

  return createdAt >= versionChangeDate;
};

// Only show the "Get your first sale" 3-step onboarding to shops installed
// on/after 2026-05-29 — the day we rolled the new onboarding out. Older
// shops have already been through the app, so the bulky checklist just gets
// in their way. Reads both camelCase and snake_case for resilience, and
// stays hidden when the install date is missing (safer to under-show the
// onboarding than to flash it at someone who shouldn't see it).
export const shouldShowOnboarding = (shopInfo) => {
  const data = shopInfo?.data || {};
  const installedAt = data.createdAt || data.created_at;
  if (!installedAt) return false;
  const parsed = new Date(installedAt);
  if (Number.isNaN(parsed.getTime())) return false;
  const cutoff = new Date('2026-05-29T00:00:00Z');
  return parsed >= cutoff;
};
